import { render, staticRenderFns } from "./OpenSupply.vue?vue&type=template&id=0394ed54&scoped=true&"
import script from "./OpenSupply.vue?vue&type=script&lang=js&"
export * from "./OpenSupply.vue?vue&type=script&lang=js&"
import style0 from "./OpenSupply.vue?vue&type=style&index=0&id=0394ed54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394ed54",
  null
  
)

export default component.exports